import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { ReliabilityAssessmentService } from '../services/reliability-assessment.service';

@Component({
  selector: 'app-cancel-evaluation-confirmation-modal',
  templateUrl: './cancel-evaluation-confirmation-modal.html',
  styleUrls: ['./cancel-evaluation-confirmation-modal.scss'],
})
export class CancelEvaluationConfirmationModal {
  @Input() workerName: string;

  constructor(
    public modalCtrl: ModalController,
    private utilityService: UtilityService,
    private reliabilityAssessmentService: ReliabilityAssessmentService,
  ) {}

  /**
   * Opt out of evaluation forms and close this modal, as well as the evaluation form modal below it.
   */
  async optOut() {
    const preferenceLoader = await this.utilityService.showLoading();
    try {
      await this.reliabilityAssessmentService.optOutReliabilityFeedback();
      await this.utilityService.showAlert('Success', 'You’ve opted out of regular evaluations.');
      this.modalCtrl.dismiss({ optout: true }); // modalCtrl.dismiss closes this modal, and closeForm: true causes the evaluation form below it to close
    } catch (e) {
      this.utilityService.showErrorAlert('Unable to perform action. Please try again later');
    } finally {
      this.utilityService.hideLoading(preferenceLoader);
    }
  }
}
